import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\Platform\WidgetMonitorController::resolve
* @see app/Http/Controllers/Admin/Platform/WidgetMonitorController.php:100
* @route '/settings/system/widget-monitor/{widgetEvent}/resolve'
*/
export const resolve = (args: { widgetEvent: number | { id: number } } | [widgetEvent: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: resolve.url(args, options),
    method: 'post',
})

resolve.definition = {
    methods: ["post"],
    url: '/settings/system/widget-monitor/{widgetEvent}/resolve',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Platform\WidgetMonitorController::resolve
* @see app/Http/Controllers/Admin/Platform/WidgetMonitorController.php:100
* @route '/settings/system/widget-monitor/{widgetEvent}/resolve'
*/
resolve.url = (args: { widgetEvent: number | { id: number } } | [widgetEvent: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { widgetEvent: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { widgetEvent: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            widgetEvent: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        widgetEvent: typeof args.widgetEvent === 'object'
        ? args.widgetEvent.id
        : args.widgetEvent,
    }

    return resolve.definition.url
            .replace('{widgetEvent}', parsedArgs.widgetEvent.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Platform\WidgetMonitorController::resolve
* @see app/Http/Controllers/Admin/Platform/WidgetMonitorController.php:100
* @route '/settings/system/widget-monitor/{widgetEvent}/resolve'
*/
resolve.post = (args: { widgetEvent: number | { id: number } } | [widgetEvent: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: resolve.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Platform\WidgetMonitorController::resolve
* @see app/Http/Controllers/Admin/Platform/WidgetMonitorController.php:100
* @route '/settings/system/widget-monitor/{widgetEvent}/resolve'
*/
const resolveForm = (args: { widgetEvent: number | { id: number } } | [widgetEvent: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: resolve.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Platform\WidgetMonitorController::resolve
* @see app/Http/Controllers/Admin/Platform/WidgetMonitorController.php:100
* @route '/settings/system/widget-monitor/{widgetEvent}/resolve'
*/
resolveForm.post = (args: { widgetEvent: number | { id: number } } | [widgetEvent: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: resolve.url(args, options),
    method: 'post',
})

resolve.form = resolveForm

const widgetMonitor = {
    resolve: Object.assign(resolve, resolve),
}

export default widgetMonitor